import React from "react";
import { useNavigate } from "react-router-dom";
import PathsLanding from "../Path/PathsLanding";
import SaverCreditTwoUp from "../AMain/SaverCreditTwoUp";

export default function SummaryNextSteps() {
  const navigate = useNavigate();

  const goToModules = () => {
    navigate("/modules");
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  return (
    // ✅ This wrapper prevents ANY child from forcing horizontal scroll
    <div style={{ width: "100%", overflowX: "hidden" }}>
      <div
        style={{
          maxWidth: "860px",
          width: "100%",              // ✅ important on mobile
          boxSizing: "border-box",     // ✅ stops padding/border overflow
          margin: "0 auto",
          padding: "2px 2px",
          borderRadius: "22px",
          border: "1px solid rgba(251, 146, 60, 0.35)",
          background: "rgba(255, 247, 237, 0.9)",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "26px",
            fontWeight: 800,
            marginBottom: "6px",
            color: "#0f172a",
          }}
        >
          Let’s summarize
        </h2>

        <p style={{ fontSize: "14px", color: "#475569", marginBottom: "16px" }}>
          <strong>Zero vs. $50,000 over time — from one tax benefit</strong>
        </p>

        <div
          style={{
            maxWidth: "680px",
            width: "100%",            // ✅ prevent child math overflow
            boxSizing: "border-box",   // ✅
            margin: "0 auto 18px",
            textAlign: "left",
            fontSize: "14px",
            lineHeight: 1.6,
            color: "#334155",
          }}
        >
          <p style={{ marginBottom: "8px" }}>
            <strong>If this was new to you:</strong> it shows why understanding
            tax rules can make a meaningful difference.
          </p>

          <div
            style={{
              background: "rgba(255, 237, 213, 0.6)",
              border: "1px solid rgba(251, 146, 60, 0.25)",
              borderRadius: "16px",
              padding: "16px",
              width: "100%",            // ✅
              boxSizing: "border-box",   // ✅
              overflowX: "hidden",       // ✅ clamps any internal overflow
            }}
          >
            <div
              style={{
                fontSize: "13px",
                fontWeight: 700,
                color: "#0f172a",
                marginBottom: "12px",
              }}
            >
              Want to see if you qualify, how to claim this, and learn it step
              by step?
            </div>

            <SaverCreditTwoUp />
          </div>

          <p style={{ marginTop: "150px" }}>
            <strong>If you already knew this:</strong> it raises a reasonable
            question — what else might exist that you haven’t seen yet?
          </p>
        </div>

        <PathsLanding />

        <p style={{ marginTop: "14px", fontSize: "11px", color: "#64748b" }} />
      </div>
    </div>
  );
}
